<template>
  <q-page class="q-pa-md bg-grey-2">
    <!-- Header Banner -->
    <q-card class="q-mb-md shadow-2 rounded-borders overflow-hidden">
      <div class="bg-primary text-white q-pa-md row items-center justify-between">
        <div class="row items-center">
          <q-icon name="event" size="md" class="q-mr-sm" />
          <div>
            <div class="text-h6 text-weight-bold">Control de Vencimientos</div>
            <div class="text-caption text-blue-2">Filtro y seguimiento de vencimiento de servicios por cliente</div>
          </div>
        </div>
      </div>

      <!-- Filtros -->
      <q-card-section class="q-pa-md">
        <div class="row q-col-gutter-md items-center">
          <div class="col-12 col-sm-6">
            <q-input
              v-model="Buscar1"
              label="RUC o Razón Social (Opcional)"
              outlined
              dense
              clearable
              @keyup.enter="BuscarVencimiento"
            />
          </div>
          <div class="col-12 col-sm-6">
            <q-select
              v-model="idservicio"
              :options="ListaServicio"
              option-value="idServicio"
              option-label="descripcion"
              emit-value
              map-options
              label="Servicio (Opcional)"
              outlined
              dense
              clearable
            />
          </div>
        </div>

        <div class="row q-col-gutter-md items-center q-mt-xs">
          <div class="col-12 col-sm-6">
            <q-input
              v-model="fechaini"
              type="date"
              label="Fecha Inicio *"
              outlined
              dense
              stack-label
            />
          </div>
          <div class="col-12 col-sm-6">
            <q-input
              v-model="fechafin"
              type="date"
              label="Fecha Vencimiento *"
              outlined
              dense
              stack-label
            />
          </div>
        </div>

        <div class="row q-col-gutter-md justify-end q-mt-sm">
          <div class="col-12 col-sm-3">
            <q-btn
              color="primary"
              icon="search"
              label="Buscar"
              class="full-width text-weight-bold"
              unelevated
              @click="BuscarVencimiento"
            />
          </div>
          <div class="col-12 col-sm-3">
            <q-btn
              color="grey-7"
              icon="clear"
              label="Limpiar Búsqueda"
              class="full-width"
              flat
              @click="LimpiarBusqueda"
            />
          </div>
        </div>
      </q-card-section>
    </q-card>

    <!-- Tabla Quasar -->
    <q-card class="shadow-2 rounded-borders">
      <q-table
        :data="ListaArticulos"
        :columns="columns"
        row-key="idServicioEmpresa"
        :grid="$q.screen.xs"
        flat
        bordered
        no-data-label="No hay registros de vencimiento para el rango seleccionado"
      >
        <template v-slot:body-cell-actions="props">
          <q-td :props="props" class="text-right">
            <q-btn
              flat
              round
              color="primary"
              icon="edit"
              size="sm"
              @click="EditarVencimiento(props.row)"
            >
              <q-tooltip>Editar Vencimiento</q-tooltip>
            </q-btn>
          </q-td>
        </template>
      </q-table>
    </q-card>

    <empresa-servicio-vencimiento
      @CerrarModal="CerrarModalVencimiento"
      :DialogServicio="DialogVencimiento"
      :ServicioVent="DatosVen"
    />
  </q-page>
</template>

<script>
import axios from "axios";
import EmpresaServicioVencimiento from "@/pages/Empresa/EmpresaVencimientoEditar";

export default {
  components: { EmpresaServicioVencimiento },
  data() {
    return {
      Buscar1: "",
      fechaini: "",
      fechafin: "",
      idservicio: "",
      ListaServicio: [],
      ListaArticulos: [],
      DialogVencimiento: false,
      DatosVen: {
        ruc: "",
        idServicioEmpresa: 0,
        descripcion: "",
        vencimiento: "",
        propio: "SI",
        estado: "V",
        observaciones: "",
      },
      columns: [
        { name: "ruc", label: "RUC", field: "ruc", align: "left", sortable: true },
        { name: "razonsocial", label: "Razón Social", field: "razonsocial", align: "left", sortable: true },
        { name: "servicio", label: "Servicio", field: "servicio", align: "left", sortable: true },
        { name: "vencimiento", label: "Vencimiento", field: "vencimiento", align: "center", sortable: true },
        { name: "observaciones", label: "Observaciones", field: row => row.observaciones || "-", align: "left", sortable: true },
        { name: "actions", label: "Acciones", field: "actions", align: "right" },
      ],
    };
  },
  created() {
    this.GetServicios();
    const today = new Date();
    const firstDay = new Date(today.getFullYear(), today.getMonth(), 1);
    const lastDay = new Date(today.getFullYear(), today.getMonth() + 1, 0);
    this.fechaini = firstDay.toISOString().substr(0, 10);
    this.fechafin = lastDay.toISOString().substr(0, 10);
    this.BuscarVencimiento();
  },
  methods: {
    GetServicios() {
      let me = this;
      axios.post("ApiWeb/ServicioListaCombo.php")
        .then((res) => {
          if (res.data && res.data.data) {
            me.ListaServicio = res.data.data;
          }
        })
        .catch((err) => console.error(err));
    },
    BuscarVencimiento() {
      if (!this.fechaini || !this.fechafin) {
        if (this.$q && this.$q.notify) {
          this.$q.notify({
            message: "El rango de fechas (Fecha Inicio y Fecha Vencimiento) es obligatorio.",
            color: "warning",
            icon: "warning",
            position: "top-right",
            timeout: 3000
          });
        } else {
          alert("El rango de fechas (Fecha Inicio y Fecha Vencimiento) es obligatorio.");
        }
        return;
      }
      let me = this;
      axios.post("ApiWeb/EmpresaVencimiento.php", {
        ruc: this.Buscar1 || "",
        idservicio: this.idservicio || "",
        fechaini: this.fechaini,
        fechafin: this.fechafin,
      })
        .then((res) => {
          if (res.data && res.data.data) {
            me.ListaArticulos = res.data.data;
          } else {
            me.ListaArticulos = [];
          }
        })
        .catch((err) => console.error(err));
    },
    LimpiarBusqueda() {
      this.Buscar1 = "";
      const today = new Date();
      const firstDay = new Date(today.getFullYear(), today.getMonth(), 1);
      const lastDay = new Date(today.getFullYear(), today.getMonth() + 1, 0);
      this.fechaini = firstDay.toISOString().substr(0, 10);
      this.fechafin = lastDay.toISOString().substr(0, 10);
      this.idservicio = "";
      this.BuscarVencimiento();
    },
    EditarVencimiento(item) {
      this.DatosVen.ruc = item.ruc;
      this.DatosVen.idServicioEmpresa = item.idServicioEmpresa || item.id;
      this.DatosVen.descripcion = item.servicio;
      this.DatosVen.vencimiento = item.vencimiento;
      this.DatosVen.observaciones = item.observaciones || "";
      this.DialogVencimiento = true;
    },
    CerrarModalVencimiento() {
      this.DialogVencimiento = false;
      this.BuscarVencimiento();
    },
  },
};
</script>
